import { css } from 'lit';

export const buttonOnDarkStyles = css`
  --_primary-button__bg: var(--sbkButtonBgColorPrimaryOnDarkEnabled);
  --_primary-button__color: var(--sbkButtonFgColorOnLightDefault);
  --_primary-button__bg--hover: var(--sbkButtonBgColorPrimaryOnDarkHover);
  --_primary-button__color--hover: var(--sbkButtonFgColorOnLightDefault);
  --_primary-button__bg--active: var(--sbkButtonBgColorPrimaryOnDarkActive);
  --_primary-button__color--active: var(--sbkButtonFgColorOnLightDefault);
  --_primary-button__bg--focus: var(--sbkButtonBgColorPrimaryOnDarkFocus);
  --_primary-button__color--focus: var(--sbkButtonFgColorOnLightDefault);
  --_primary-button__bg--disabled: var(--sbkButtonBgColorPrimaryOnDarkDisabled);
  --_primary-button__color--disabled: var(--sbkButtonFgColorOnLightDefault);

  --_secondary-button__bg: var(--sbkButtonBgColorSecondaryOnDarkEnabled);
  --_secondary-button__color: var(--sbkButtonSecondaryFgColorOnDarkEnabled);
  --_secondary-button__bg--hover: var(--sbkButtonBgColorSecondaryOnDarkHover);
  --_secondary-button__color--hover: var(--sbkButtonFgColorOnDarkDefault);
  --_secondary-button__bg--active: var(--sbkButtonBgColorSecondaryOnDarkActive);
  --_secondary-button__color--active: var(--sbkButtonFgColorOnDarkDefault);
  --_secondary-button__bg--focus: var(--sbkButtonBgColorSecondaryOnDarkFocus);
  --_secondary-button__color--focus: var(--sbkButtonFgColorOnLightDefault);
  --_secondary-button__bg--disabled: var(--sbkButtonBgColorSecondaryOnDarkDisabled);
  --_secondary-button__color--disabled: var(--sbkButtonFgColorOnDarkDisabled);
  --_secondary-button__border-color: var(--sbkButtonBorderOnDarkEnabled);
  --_secondary-button__border-color--active: var(--sbkButtonBorderOnDarkActive);
  --_secondary-button__border-color--focus: var(--sbkButtonBorderOnDarkFocus);
  --_secondary-button__border-color--hover: var(--sbkButtonBorderOnDarkHover);
  --_secondary-button__border-color--disabled: var(--sbkButtonBorderOnDarkDisabled);

  --_cta-button__bg: var(--sbkButtonBgColorCtaOnDarkEnabled);
  --_cta-button__color: var(--sbkButtonFgColorOnLightDefault);
  --_cta-button__bg--hover: var(--sbkButtonBgColorCtaOnDarkHover);
  --_cta-button__color--hover: var(--sbkButtonFgColorOnLightDefault);
  --_cta-button__bg--active: var(--sbkButtonBgColorCtaOnDarkActive);
  --_cta-button__color--active: var(--sbkButtonFgColorOnLightDefault);
  --_cta-button__bg--disabled: var(--sbkButtonBgColorCtaOnDarkDisabled);
  --_cta-button__color--disabled: var(--sbkButtonFgColorOnLightDisabled);

  --_button__border--focus: var(--sbkButtonBorderOnDarkFocus);

  --_round-button__bg: var(--sbkRoundButtonBgColorOnDarkEnabled);
  --_round-button__color: var(--sbkRoundButtonFgColorOnLightDefault);
  --_round-button__bg--hover: var(--sbkRoundButtonBgColorOnDarkHover);
  --_round-button__color--hover: var(--sbkRoundButtonFgColorOnDarkDefault);
  --_round-button__bg--active: var(--sbkRoundButtonBgColorOnDarkActive);
  --_round-button__color--active: var(--sbkRoundButtonFgColorOnDarkDefault);
  --_round-button__bg--focus: var(--sbkRoundButtonBgColorOnDarkFocus);
  --_round-button__color--focus: var(--sbkRoundButtonFgColorOnDarkDefault);
  --_round-button__bg--disabled: var(--sbkRoundButtonBgColorOnDarkDisabled);
  --_round-button__color--disabled: var(--sbkRoundButtonFgColorOnDarkDefault);
  --_round-button__border-color: var(--sbkButtonBorderOnDarkEnabled);
  --_round-button__border-color--active: var(--sbkButtonBorderOnDarkActive);
  --_round-button__border-color--focus: var(--sbkButtonBorderOnDarkFocus);
  --_round-button__border-color--hover: var(--sbkButtonBorderOnDarkHover);
  --_round-button__border-color--disabled: var(--sbkButtonBorderOnDarkDisabled);
`;
